import { Component, Input, ViewEncapsulation, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'nbx-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
  
})
export class SelectComponent implements OnInit, OnChanges {

  @Input() placeholder = 'select';
  @Input() menutitle = 'Select an option';
  @Input() multiple = false;
  @Input() status = 'primary';
  @Input() shape = 'semi-round';
  @Input() size = 'medium';
  @Input() selected = null;
  @Input() filled = false;
  @Input() hero = false;
  @Input() opts;
  options

  @Output() selectedvalue = new EventEmitter()

  ngOnInit() {
    
    this.options = this.opts ? JSON.parse(this.opts) : [
      { value: "1", label: "Option 1"},
      { value: "2", label: "Option 2"},
      { value: "3", label: "Option 3"},
    ] 
  }

  ngOnChanges(changes: SimpleChanges) {
    for(const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        if (propName === "opts")
        {
          this.options = this.opts ? JSON.parse(this.opts) : [
            { value: "1", label: "Option 1"},
            { value: "2", label: "Option 2"},
            { value: "3", label: "Option 3"},           
          ]
        }
      }
    }
  }

  sendValue(e) {
    this.selectedvalue.emit(e);
  }
}